import { Navigate } from "react-router";

import Login from "src/pages/login";
import Clientes from "src/pages/Clientes";
import DashboardLayout from "src/layouts/DashboardLayout";
import DashboardMapa from "./pages/Dashboard/Mapa";
import DashboardResumo from "./pages/Dashboard/Resumo";
import Configuracoes from "./pages/Configuracoes";
import Perfil from "./pages/Perfil";
import Cashback from "./pages/Cashback";
import Produtos from "./pages/Produtos";
import CategoriasProdutos from "./pages/CategoriasProdutos";
import ComplementosProdutos from "./pages/ComplementosProdutos";
import Entregadores from "./pages/Entregadores";
import Pedidos from "./pages/Pedidos";
import Usuarios from "./pages/Usuarios";
import Dashboard from "./pages/Dashboard";
import Pagamentos from "./pages/Pagamentos";
import Comanda from "./pages/Comanda";
import RecuperarSenha from "./pages/RecuperarSenha";
import ResetarSenha from "./pages/ResetarSenha";

const routes = [
  {
    path: "/",
    children: [{ path: "/", element: <Login /> }],
  },
  { path: "/recuperar-senha", element: <RecuperarSenha /> },
  { path: "/resetar-senha/:token", element: <ResetarSenha /> },
  {
    path: "/app",
    element: <DashboardLayout />,
    children: [
      { path: "/dashboard", element: <Dashboard /> },
      { path: "/dashboard/mapa", element: <DashboardMapa /> },
      { path: "/dashboard/resumo", element: <DashboardResumo /> },
      { path: "/clientes", element: <Clientes /> },
      { path: "/configuracoes", element: <Configuracoes /> },
      { path: "/perfil", element: <Perfil /> },
      { path: "/cashback", element: <Cashback /> },
      { path: "/produtos", element: <Produtos /> },
      { path: "/categorias", element: <CategoriasProdutos /> },
      { path: "/complementos", element: <ComplementosProdutos /> },
      { path: "/entregadores", element: <Entregadores /> },
      { path: "/pedidos", element: <Pedidos /> },
      { path: "/usuarios", element: <Usuarios /> },
      // { path: "/pagamentos", element: <Pagamentos /> },
      { path: "/comanda", element: <Comanda /> },
      { path: "*", element: <Navigate to="/login" /> },
    ],
  },
];

export default routes;
